var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-page"},[_c('score',{staticClass:"score",attrs:{"player":_vm.score['PLAYER'],"bot":_vm.score['BOT'],"renderPending":_vm.renderPending},on:{"score-action-rendered":_vm.actionRendered}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }